import { useEffect, useState } from 'react';

import {
    Button,
    Card,
    FormControl,
    FormLabel,
    Heading,
    Icon,
    IconButton,
    Input,
    InputGroup,
    InputRightElement,
    Link,
    useBreakpointValue
} from '@chakra-ui/react';

import { AiOutlineClose } from "react-icons/ai";
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import { FiExternalLink } from "react-icons/fi";

export function LoginForm({requestActive, loginRequest, isCheckIn=0}) {

    const [inputUser, setInputUser] = useState("");
    const [inputPassword, setInputPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const showPasswordOnClick = useBreakpointValue(
        {
          "base": ()=>setShowPassword(showPassword ? false : true),
          "xl": ()=>{}
        }
    );
    
    const showPasswordOnMouseUp = useBreakpointValue(
        {
          "base": ()=>{},
          "xl": ()=>setShowPassword(false)
        }
    );

    const showPasswordOnMouseDown = useBreakpointValue(
        {
          "base": ()=>{},
          "xl": ()=>setShowPassword(true)
        }
    );

    const showPasswordIcon = useBreakpointValue(
        {
          "base": showPassword ? <FaEyeSlash/> : <FaEye/>,
          "xl": <FaEye/>
        }
    );       

    const validUser = inputUser.length > 0;
    const validPassword = inputPassword.length > 0;

    const loginValid = validUser && validPassword && !requestActive;

    const loginText = isCheckIn ? "Check in" : "Log in";

    try {
        return (
            <Card 
                width="90%"
                maxWidth="300px"
                marginLeft="auto" 
                marginRight="auto" 
                textAlign="center"
                padding={10}
            >
                <Heading size="md" ml="auto" mr="auto" mb={4}>GrooveStats Log In</Heading>
                <form>
                    <InputGroup>
                        <FormControl variant="floatingCard">
                            <Input
                                autoComplete="username"
                                fontSize="sm"
                                placeholder=""
                                value={inputUser}
                                onInput={newInputUser => {setInputUser(newInputUser.target.value)}}
                                isDisabled={requestActive}
                                maxLength={25}
                                marginBottom={4}
                                onKeyDown={e=> {
                                    if (e.key === 'Enter' && loginValid) {
                                        loginRequest(inputUser, inputPassword);
                                    }
                                }}
                            />
                            <FormLabel>User</FormLabel>
                        </FormControl>
                        <InputRightElement>
                            <IconButton
                                variant="ghost"
                                icon={<AiOutlineClose/>}
                                onClick={()=>{setInputUser("")}}
                                size="xs"
                                borderRadius="12px"
                                tabIndex="-1"
                            />
                        </InputRightElement>
                    </InputGroup>
                    <InputGroup>
                        <FormControl variant="floatingCard">
                                <Input
                                    autoComplete="current-password"
                                    fontSize="sm"
                                    placeholder=""
                                    value={inputPassword}
                                    onInput={newInputPassword => {setInputPassword(newInputPassword.target.value)}}
                                    isDisabled={requestActive}
                                    type={showPassword ? 'text' : 'password'}
                                    maxLength={20}
                                    marginBottom={2}
                                    onKeyDown={e=> {
                                        if (e.key === 'Enter' && loginValid) {
                                            loginRequest(inputUser, inputPassword, isCheckIn);
                                        }
                                    }}
                                />
                            <FormLabel>Password</FormLabel>
                        </FormControl>              
                        <InputRightElement width="4.5rem">
                            <IconButton
                                variant="ghost"
                                icon={<AiOutlineClose/>}
                                onClick={()=>{setInputPassword("")}}
                                size="xs"
                                borderRadius="12px"
                                marginRight={2}
                                tabIndex="-1"
                            />
                            <IconButton
                                icon={showPasswordIcon}
                                onMouseDown={()=>showPasswordOnMouseDown()}
                                onMouseUp={()=>showPasswordOnMouseUp()}
                                onClick={()=>showPasswordOnClick()}
                                size="xs"
                                borderRadius="5px"
                                isDisabled={inputPassword?.length < 1}
                                tabIndex="-1"
                            />
                        </InputRightElement>
                    </InputGroup>      
                    <Button
                        width="100%"
                        mb={4}
                        onClick={()=>{loginRequest(inputUser, inputPassword, isCheckIn)}}
                        isDisabled={!validUser || !validPassword || requestActive}
                    >
                        {loginText}
                    </Button>
                </form>
                <Link color='teal.300' href={`https://groovestats.com/index.php?page=register`} isExternal>Register for GrooveStats <Icon as={FiExternalLink} mx='2px' top='3px' position="relative"/></Link>
            </Card>
        );
    } catch (e) {
        console.error("LoginForm render error: ", e);
    }
}